import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedVimeoVideoLazy } from '../../../shared/PdpSharedVimeoVideo/PdpSharedVimeoVideoLazy';

import { VimeoVideo_videoVimeo$key } from './__generated__/VimeoVideo_videoVimeo.graphql';

const videoVimeoFragment = graphql`
    fragment VimeoVideo_videoVimeo on VideoVimeo {
        vimeoId
    }
`;

export const VimeoVideo: FC<{
    videoVimeo: VimeoVideo_videoVimeo$key;
}> = ({ videoVimeo }) => {
    const videoVimeoData = useFragment(videoVimeoFragment, videoVimeo);

    return <PdpSharedVimeoVideoLazy id={videoVimeoData.vimeoId} useDefaultControls />;
};
